import { render, staticRenderFns } from "./TraxUiVerticalTimeline.vue?vue&type=template&id=f909bd92"
import script from "./TraxUiVerticalTimeline.vue?vue&type=script&lang=js"
export * from "./TraxUiVerticalTimeline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports